import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Menu,
  MenuItem,
  Avatar,
  Tooltip,
  IconButton,
  ListItemIcon,
  CircularProgress,
} from "@mui/material";
import { ReactKeycloakProvider, useKeycloak } from "@react-keycloak/web";
import keycloak from "./keycloak";
import Cookies from "js-cookie";
import Keycloak from "keycloak-js";
import MainLayout from "./layouts/MainLayout";
let ltiKeycloak: any;
const lxpDomain = process.env.REACT_APP_PRISM_URL || "";

const App: React.FC = () => {
  const { keycloak, initialized } = useKeycloak();
  const [userName, setUserName] = useState<string>("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState<boolean>(true);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (initialized) {
      if (keycloak?.authenticated) {
        // Set localStorage after successful authentication

        localStorage.setItem("maiaskToken", keycloak.token || "");

        const user = keycloak.tokenParsed;
        if (user) {
          console.log(user);
          localStorage.setItem("user", user.email || "");
          const id = user.prismId || "";
          const firstName = user.given_name || "";
          const lastName = user.family_name || "";
          setUserName(`${firstName} ${lastName}`);
          localStorage.setItem(
            "maiAskUser",
            JSON.stringify({ email: user.email, prismId: id })
          );
        } else {
          setUserName("");
        }
      } else {
        setUserName("");
        if (!lxpDomain) {
          keycloak?.login();
        } else {
          window.location.href = lxpDomain;
        }
      }
      setLoading(false);
    }
  }, [initialized, keycloak]);

  // useEffect(() => {
  //   if (initialized && !keycloak?.authenticated) {
  //     // keycloak?.login();
  //     window.location.href = lxpDomain
  //   }
  // }, [initialized, keycloak]);

  // if (loading) {
  //   return <Box
  //     sx={{
  //       position: "fixed",
  //       top: 0,
  //       left: 0,
  //       width: "100vw",
  //       height: "100vh",
  //       bgcolor: "white",
  //       display: "flex",
  //       flexDirection: "column",
  //     }}
  //   >
  //     {/* UpGrad Logo in the Top Left */}
  //     <Box sx={{ pt: 3, ml: 4.25 }}>
  //       <img
  //         src="https://www.upgrad.com/_ww3-next/_next/static/media/upgrad-header-logo.325f003e.svg"
  //         alt="UpGrad Logo"
  //         style={{ height: "40px" }}
  //       />
  //     </Box>

  //     {/* Centered Loader */}
  //     <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
  //       <CircularProgress size={60} sx={{ color: "black" }} />
  //       <Typography variant="h6" sx={{ mt: 2, textAlign: "center" }}>
  //         Loading...
  //       </Typography>
  //     </Box>
  //   </Box>
  // }

  return (
    <>
      {keycloak?.authenticated && userName && (
        <>{keycloak?.authenticated ? <MainLayout /> : <p>Loading...</p>}</>
      )}
    </>
  );
};

const keycloakConfig: any = {
  authClient: keycloak,
  onEvent: (event: any) => {
    if (event === "onAuthenticated") {
      console.log("User authenticated");
    } else if (event === "onTokenExpired") {
      console.log("Token expired");
    }
  },
};

const AppWithKeycloakProvider: React.FC = () => {
  const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM || "";
  const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;

  const [canLoad, setCanLoad] = useState(false);
  const [ltiToken, setLtiToken] = useState<any>({});
  const [mergedKeycloakInitOptions, setMergedKeycloakInitOptions] = useState(
    {}
  );

  const onEvent = async (event: string, error: any) => {
    try {
      switch (event) {
        case "onAuthSuccess": {
          console.log("onAuthSuccess");
          break;
        }

        case "onAuthLogout":
        case "onAuthRefreshError": {
          sessionStorage.clear();
          break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getToken = (name: string) => {
    try {
      const token =
        Cookies.get(name) || localStorage.getItem(name) || getLtiMergedToken();

      if (token) {
        const tokenData = JSON.parse(token);

        if (tokenData.refreshToken) {
          ltiKeycloak = new Keycloak({
            realm: keycloakRealm,
            url: keycloakUrl,
            clientId: "ira-frontend",
          });

          setMergedKeycloakInitOptions({
            token: tokenData?.accessToken,
            refreshToken: tokenData?.refreshToken,
            checkLoginIframe: false,
            onLoad: "check-sso",
            silentCheckSsoRedirectUri:
              window.location.origin + "/silent-check-sso.html",
          });

          setLtiToken(tokenData);

          sessionStorage.setItem(
            "kcProfile",
            tokenData?.refreshToken
              ? JSON.stringify({ ...tokenData, token: tokenData?.accessToken })
              : JSON.stringify(keycloak)
          );
        }
        setCanLoad(true);
        return tokenData;
      }
      setCanLoad(true);
      return null;
    } catch (e) {
      setCanLoad(true);
      Cookies.remove(name);
      return null;
    }
  };

  const getLtiMergedToken = () => {
    const accessToken = Cookies.get("ltiAccessToken");
    const refreshToken = Cookies.get("ltiRefreshToken");

    return JSON.stringify({
      accessToken,
      refreshToken,
    });
  };

  useEffect(() => {
    getToken("ltiToken");
  }, []);

  return (
    <ReactKeycloakProvider
      initOptions={mergedKeycloakInitOptions}
      onEvent={onEvent}
      authClient={ltiToken?.refreshToken ? ltiKeycloak : keycloak}
    >
      <App />
    </ReactKeycloakProvider>
  );
};

export default AppWithKeycloakProvider;
